/**
 * @generated SignedSource<<d71226e7021945d776875dcb36e046e7>>
 * @relayHash c6b8d697c662945f1be793b236d5268a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebf6d75990b777e3b54020417e3b137ce036122fc4dfdaab478c4b99964a4d3d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetFieldSetsPreferencesInput = {
  fieldSetsPreferences?: ReadonlyArray<JiraFieldSetPreferencesInput> | null | undefined;
  viewId: string;
};
export type JiraFieldSetPreferencesInput = {
  fieldSetId: string;
  width?: number | null | undefined;
};
export type main_setFieldSetsPreferencesMutation$variables = {
  input: JiraSetFieldSetsPreferencesInput;
};
export type main_setFieldSetsPreferencesMutation$data = {
  readonly jira_setFieldSetsPreferences: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type main_setFieldSetsPreferencesMutation = {
  response: main_setFieldSetsPreferencesMutation$data;
  variables: main_setFieldSetsPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JiraSetFieldSetsPreferencesPayload",
    "kind": "LinkedField",
    "name": "jira_setFieldSetsPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "main_setFieldSetsPreferencesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "main_setFieldSetsPreferencesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ebf6d75990b777e3b54020417e3b137ce036122fc4dfdaab478c4b99964a4d3d",
    "metadata": {},
    "name": "main_setFieldSetsPreferencesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "66ced461f53670977bbff1972c370ba4";

export default node;
